import React, { useState } from "react";
import { getMerchantSections } from "../data/merchantLinks";
import { featureSlugFromName } from "../utils/sidebarStorage";
import SidebarNavItem from "./SidebarNavItem";
import SidebarSection from "./SidebarSection";

export default function MerchantNavigation({ entityRole, activeKey, onNavigate }) {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionTitle) => {
    setOpenSections((current) => ({
      ...current,
      [sectionTitle]: !current[sectionTitle],
    }));
  };

  return (
    <>
      {getMerchantSections(entityRole).map((section) => {
        const sectionActive = section.items.some((item) => {
          const route = featureSlugFromName(item.name);
          return activeKey === item.name || activeKey?.toLowerCase() === route;
        });

        return (
          <SidebarSection
            title={section.title}
            key={section.title}
            active={sectionActive}
            open={!!openSections[section.title]}
            onToggle={() => toggleSection(section.title)}
          >
            {section.items.map((item) => {
              const route = featureSlugFromName(item.name);
              const active =
                activeKey === item.name || activeKey?.toLowerCase() === route;

              return (
                <SidebarNavItem
                  key={item.name}
                  label={item.label || item.name}
                  active={active}
                  compact
                  onClick={() => onNavigate(route, item.name)}
                />
              );
            })}
          </SidebarSection>
        );
      })}
    </>
  );
}
